import { cardBinLength } from '../../constants';
import { getCardInfoByBin } from '../../requests';

type Params = {
  cardNumber: string;
  excludeCardCountryCodes: Array<{
    code: string;
    message: string;
  }>;
};

const IN_PROGRESS_STATE = 'IN_PROGRESS';
const binCountriesCache: Record<string, string> = {};

export const validateByCountryCode = async ({ cardNumber, excludeCardCountryCodes }: Params) => {
  const bin = cardNumber.replace(/\s/g, '').slice(0, cardBinLength);

  if (bin.length < cardBinLength) {
    return null;
  }

  // Чтобы не отправлять для одинакового бина одновременно несколько запросов делается эта проверка
  // Дебауном на onChange на уровне компонента это не решить
  // При вставке номера карты событие onChange срабатывает 1 раз, но валидация yup срабатывает на каждый символ.
  if (binCountriesCache[bin] === IN_PROGRESS_STATE) {
    return null;
  }

  if (!binCountriesCache[bin]) {
    binCountriesCache[bin] = IN_PROGRESS_STATE;
    const { countryCode: responseCountryCode } = await getCardInfoByBin({ bin });
    binCountriesCache[bin] = responseCountryCode;
  }

  const countryCode = binCountriesCache[bin];

  const excludeRule = excludeCardCountryCodes.find(
    ({ code }) => code.toUpperCase() === countryCode
  );

  if (excludeRule) {
    return excludeRule.message;
  }

  return null;
};
